import { Inertia } from '@inertiajs/inertia'
import { FunctionalComponent, h } from '@stencil/core'
import Axios from 'axios'
import { asyncToast } from 'src/app/toast'
import { ICall } from 'src/call/types'

export const CallDeleteDialog: FunctionalComponent<{
  call: ICall
  onClosed: (success: boolean) => void
  nextUrl?: string
}> = ({ call, onClosed, nextUrl }) => {
  const dialogClosed = () => {
    onClosed(false)
  }

  const performDelete = async (dialog: HTMLUiDialogElement) => {
    const deletePromise = Axios.delete(call.delete_url)
    asyncToast(deletePromise, 'Deleting call…', 'Done!', 'Error deleting call!', 'info-warn')

    await deletePromise
    await dialog.close()

    if (nextUrl) {
      Inertia.visit(nextUrl)
    } else {
      onClosed(true)
    }
  }

  return (
    <ui-dialog
      onClosed={dialogClosed}
      content={({ dialog }) => (
        <div
          class={`flex flex-col border-info-error border-2 items-center relative text-center p-6 justify-center rounded-md bg-surface-upper text-md`}
          style={{ maxWidth: '640px' }}
        >
          <ui-icon
            onClick={async () => {
              await dialog.close()
            }}
            class='absolute top-0 right-0 mt-1 mr-1 text-3xl text-surface-highest hover:text-glyph-base cursor-pointer'
            icon='x'
          />
          <p class='flex flex-col items-center spacing-y-2'>
            <ui-icon class='text-3xl text-info-error' icon='exclamation-triangle-filled' />
            <h3 class='flex items-center text-lg font-bold '>This action cannot be undone.</h3>
            <p class='not-italic font-medium leading-xl'>
              This will permanently delete the call
              <br />
              <em>“{call.title}”</em>
            </p>
          </p>
          <button
            class='py-1 px-3 mt-3 text-base font-bold bg-info-error rounded-md'
            type='submit'
            onClick={() => {
              performDelete(dialog)
            }}
          >
            Yes, Delete this call
          </button>
        </div>
      )}
    />
  )
}
